import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconFlipVertically12 from './IconFlipVertically12';
import IconFlipVertically16 from './IconFlipVertically16';
import IconFlipVertically20 from './IconFlipVertically20';
import IconFlipVertically24 from './IconFlipVertically24';
import IconFlipVertically32 from './IconFlipVertically32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconFlipVertically = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconFlipVertically12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconFlipVertically16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconFlipVertically20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconFlipVertically24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconFlipVertically32 {...props} />}
        </span>
    );
};
IconFlipVertically.displayName = 'FondueIconFlipVertically';

export default memo(IconFlipVertically);
